module.exports = __webpack_public_path__ + "img/pop_logo.6db55c45.png";